module.exports = __webpack_public_path__ + "img/amazon.45f9aa28.svg";